import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { Eye, Send, Pencil } from "lucide-react";
import { getVzDigestDealers, previewVzEmail, sendVzEmailSample } from "@/lib/verizonSalesApi";
import { EmailTemplateEditor } from "./EmailTemplateEditor";

export const EmailSampleBar = ({ kind }) => {
  const [dealers, setDealers] = useState([]);
  const [dealerId, setDealerId] = useState("");
  const [preview, setPreview] = useState(null);
  const [editing, setEditing] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const load = () => getVzDigestDealers().then((d) => {
      setDealers(d); setDealerId((cur) => (d.some((x) => x.id === cur) ? cur : d[0]?.id || ""));
    }).catch(() => {});
    load();
    window.addEventListener("vz-exclusions-changed", load);
    return () => window.removeEventListener("vz-exclusions-changed", load);
  }, []);

  const run = async (fn) => {
    setBusy(true);
    try { await fn(); } catch (e) { toast.error(e.response?.data?.detail || "Something went wrong"); }
    setBusy(false);
  };
  const doPreview = () => run(async () => setPreview(await previewVzEmail(kind, { dealer_id: dealerId })));
  const doSend = () => run(async () => { const r = await sendVzEmailSample(kind, { dealer_id: dealerId }); toast.success(`Sample sent to ${r.sent_to}`); });

  return (
    <div className="space-y-3" data-testid={`vz-email-sample-${kind}`}>
      <div className="flex gap-2 flex-wrap items-center">
        <Select value={dealerId} onValueChange={setDealerId}>
          <SelectTrigger className="h-9 w-72 text-xs" data-testid={`vz-email-sample-${kind}-dealer`}><SelectValue placeholder="Sample dealer" /></SelectTrigger>
          <SelectContent>{dealers.map((d) => <SelectItem key={d.id} value={d.id}>{d.name || d.email}</SelectItem>)}</SelectContent>
        </Select>
        <Button variant="outline" onClick={doPreview} disabled={busy || !dealerId} data-testid={`vz-email-sample-${kind}-preview`}><Eye className="w-4 h-4 mr-1" /> Preview sample email</Button>
        <Button onClick={doSend} disabled={busy || !dealerId} data-testid={`vz-email-sample-${kind}-send`}><Send className="w-4 h-4 mr-1" /> Send sample to me</Button>
        <Button variant="ghost" onClick={() => setEditing(true)} data-testid={`vz-email-sample-${kind}-edit`}><Pencil className="w-4 h-4 mr-1" /> Edit email</Button>
      </div>
      {preview && (
        <div className="border border-slate-200 rounded-lg overflow-hidden" data-testid={`vz-email-sample-${kind}-frame`}>
          <div className="text-xs bg-slate-50 px-3 py-1.5 text-slate-600">{preview.subject} · sample for {preview.dealer_name}</div>
          <iframe title={`${kind} sample`} srcDoc={preview.html} className="w-full h-[560px] bg-white" />
        </div>
      )}
      <EmailTemplateEditor kind={kind} open={editing} onOpenChange={setEditing} dealerId={dealerId} />
    </div>
  );
};
